import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptors } from "../../app/store/baseQueryWithReauth";
import { reducerPathEnums } from "../../shared/types/common-types";

export const openaiApi = createApi({
	tagTypes: ["openai"],
	reducerPath: reducerPathEnums.Openai,
	baseQuery: baseQueryWithInterceptors,
	endpoints: (builder) => ({
		generateSpeakingFeedback: builder.mutation({
			query: (data) => ({
				url: "/ai/speakingFeedback",
				method: "POST",
				body: data,
			}),
		}),
	}),
});

export const { useGenerateSpeakingFeedbackMutation } = openaiApi;
